/* About.js */
import React from 'react';
import './css/About.css';

const About = () => {
  return (
    <div className="about-container">
      <p>
        I like building stuff, changing stuff, modifying things, and 
        I like to pick things apart. My curiosity stretch far and wide, 
        and within the field of science this curiosity is more or less immeasurable
      </p>
    </div>
  );
};

export default About;
